import type { FunctionComponent, PropsWithChildren } from "react";

import { FLAGS_FORCED_ON } from "./flags.config";
import type { FlagsState, IFlagsService } from "./flags.types";

/* Used when no Amplitude Experiment key is configured (local/dev/on-prem).
 * Renders children untouched and resolves every flag to off — so anything gated
 * behind a flag (e.g. the Stigg billing UI, gated on `stigg-enabled`) stays
 * hidden. Reports ready so gated consumers don't hang on a loading state.
 *
 * The one exception is VITE_FLAGS_ON, which forces named flags on so in-progress
 * UI can be reviewed locally. It only exists on this impl — an env with a
 * deployment key never reaches here, so it can't override a real rollout. */
export class NoopFlagsService implements IFlagsService {
  FlagsProvider: FunctionComponent<PropsWithChildren<unknown>> = ({
    children,
  }) => <>{children}</>;

  useFlags = (): FlagsState => ({
    ready: true,
    isEnabled: (flagKey: string) => FLAGS_FORCED_ON.includes(flagKey),
  });

  /** Deliberately ON (unlike isEnabled's fail-off): a keyless env (local
   *  Caddy auth, tests) is a debugging context, and hiding the only
   *  credential-entry path there would lock sign-in behind Google alone. */
  useEmailPasswordAuth = () => ({ ready: true, enabled: true });
}
